import Chip from "@mui/material/Chip";
import { colors } from "healthex-common/colors";
import styled from "styled-components";
import { multilineEllipsis } from "./base.styles";
import { FlexColumn, FlexColumnDiv, FlexRow, HorizontalDivider } from "./common.styles";
import { HXButton } from "./HXButton";
import { HXPage, pageHorizontalMargin } from "./HXDesktopPage";
import { HXPageTitleText, SemiBoldText } from "./HXDesktopPage.styles";
export const PatientsSearchTitle = styled(HXPageTitleText) `
    ${multilineEllipsis(1)}
`;
export const PatientsSearchParent = styled(HXPage) `
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
`;
export const PatientsSearchPendingConsentContainerWrapper = styled(FlexColumn) `
    gap: 24px;
    padding: 0 0 24px 0;
`;
export const PatientsSearchSearchContainer = styled(FlexRow) `
    padding: 16px 0;
    gap: 16px;
`;
export const PatientsSearchSearchDivider = styled(HorizontalDivider) `
    position: relative;
    left: -${pageHorizontalMargin}px;
    width: calc(100% + ${pageHorizontalMargin * 2}px);
`;
export const PatientsSearchPatientInfoContainer = styled(FlexColumn) `
    padding: 24px 0 32px 0;
    gap: 24px;
    align-self: stretch;
`;
export const PatientsSearchPendingConsentContainer = styled(FlexColumn) `
    padding: 24px;
    justify-content: flex-end;
    gap: 16px;

    border-radius: 4px;
    border: 1px solid ${colors.sunset_main};
    background: ${colors.sunset_8};
`;
export const PatientsSearchPendingConsentList = styled(FlexRow) `
    gap: 24px;
    flex-wrap: wrap;
`;
export const PatientsSearchPendingConsentCard = styled(FlexColumnDiv) `
    height: 240px;
    padding: 16px;
    min-width: 310px;
    gap: 24px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    border: 1px solid ${colors.navy_12};
    background: ${colors.white_main};
    flex: 0 0 calc(33.33% - 16px); // 16 = 2 * 24 / 3 = 2 gaps * 24px padding / 3 items
`;
export const PatientsSearchPendingConsentCardTitle = styled(SemiBoldText) `
    ${multilineEllipsis(2)}
    height: 36px;
    word-break: break-word;
`;
export const PatientsSearchPendingConsentCardButtonsContainer = styled(FlexColumn) `
    gap: 4px;
    justify-content: center;
    align-items: center;
`;
export const PatientsSearchPendingConsentCardChip = styled(Chip).attrs({ size: "medium" }) `
    background-color: ${colors.black_8};
`;
export const PatientsSearchPendingConsentCardButton = styled(HXButton).attrs({ secondary: true }) `
    align-self: stretch;
`;
export const PatientsSearchPendingConsentCardOtherInfo = styled(FlexColumnDiv) `
    gap: 4px;
`;
